<template>
  <div>
    <div class="tutorial-start">
      <div v-show="bookTutorial.step === 1" class="tutorial-start__item">
        <h5 class="tutorial-start__title">Welcome!</h5>
        <p class="tutorial-start__text">
          Let’s go on a quick tour of a Shortform book guide.
        </p>
        <div class="tutorial-start__btn-box">
          <a
            class="tutorial-start__btn tutorial-start__btn--no-arr tutorial-next btns"
            @click="bookTutorial.incrementStep()"
            >Start</a
          >
          <!--
          The 'Later' button is implemented by CSS vendor, but we decided
          not to show it for now, to force users go through the
          quesionnaire.
          a
            href="javascript:void(0);"
            class="tutorial-start__btn tutorial-start__btn--no-arr tutorial-start__btn--white tutorial-close btns"
            >Later</a
          -->
        </div>
      </div>
      <transition name="fade">
        <div v-show="bookTutorial.step === 2" class="tutorial-start__item">
          <!--
          The 'Later' button is implemented by CSS vendor, but we decided
          not to show it for now, to force users go through the
          quesionnaire.
          a
            class="tutorial-start__close tutorial-close"
            ><span class="iconfont iclose"></span
          ></a>-->
          <h5 class="tutorial-start__title">1-Page Summary</h5>
          <p class="tutorial-start__text">
            Every guide starts with a 1-Page Summary. This is a 5-10 minute
            overview of the book’s key points.
          </p>
          <div class="tutorial-start__btn-box">
            <a
              class="tutorial-start__btn tutorial-next btns"
              @click="bookTutorial.incrementStep()"
              >Next<span class="tutorial-start__btn-arr iconfont inext"></span
            ></a>
          </div>
        </div>
      </transition>
    </div>
    <transition name="fade">
      <div v-if="showTutorialQuestion" class="tutorial-question">
        <div
          v-show="bookTutorial.step === 8"
          class="tutorial-start__item tutorial-start__question"
        >
          <h5 class="tutorial-start__title">Finished!</h5>
          <p class="tutorial-start__text">
            If you ever need to see this tour again, click here.
          </p>
          <div class="tutorial-start__btn-box">
            <a
              class="tutorial-start__btn tutorial-start__btn--no-arr tutorial-close btns"
              @click="bookTutorial.resetStep()"
              >Close</a
            >
          </div>
        </div>
        <a
          v-show="bookTutorial.isVisible()"
          class="tutorial-question__btn"
          @click="bookTutorial.start()"
        >
          <span class="tutorial-question__icon iconfont iquestion"></span>
          <span class="tutorial-question__tips">Guided Tour</span>
        </a>
      </div>
    </transition>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { BookTutorial } from '@/models/doc.tutorial'

const props = defineProps<{
  bookTutorial: BookTutorial
}>()

const showTutorialQuestion = computed(() => {
  return props.bookTutorial.step === 8 || props.bookTutorial.isVisible()
})
</script>
